import React from 'react';
import FormControl from "@material-ui/core/FormControl";
import {FormHelperText, IconButton, InputAdornment, InputLabel, MenuItem, Select} from "@material-ui/core";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import {MultipleSelect} from '../'

function Input(props) {

  const {
    item,
    onChange,
  } = props;

  const {
    id,
    type = 'text',
    label,
    placeholder,
    labelWidth = 53,
    dropdownList = [],
    errorText,
    value,
    error,
    required = true,
    min, max,
    disable = false,
    multiline = false,
    defaultValue = '',
    rows = 1
  } = item;

  return (
    <div>
      <FormControl
        variant="outlined"
        fullWidth
        // margin='dense'
        error={error ? error : false}
        style={{border: 'none', borderBottomWidth: 1, borderColor: 'red',}}
      >
        <InputLabel htmlFor={id} error={error}>
          {label}
          {required && <sup className='error-class ml-2'>*</sup>}
        </InputLabel>

        {
          (item?.type === 'select') ?
            <>
              {item?.multipleValues === true ?
                <MultipleSelect item={item} value={value} onChange={onChange} dropdownList={dropdownList}/>
                : <Select
                  required={required}
                  id={id || label}
                  value={value}
                  onChange={(event) => {
                    onChange(event.target.value, id || label)
                  }}
                  label={label}
                  labelWidth={labelWidth}
                  disabled={disable}
                  defaultValue={defaultValue}
                >
                  {/*https://deep-0301.github.io/multi-step-form/*/}
                  {/*https://github.com/deep-0301/multi-step-form*/}
                  <MenuItem value="">
                    <em>Please Select</em>
                  </MenuItem>
                  {dropdownList.map((val, index) => (
                    <MenuItem value={val.value} key={`${val.value + index}`}
                              className='display-flex align-items-center text-capitalize'>
                      {val?.icon && <img src={val.icon} alt={''} width={30} className='mr-10'/>}
                      {val.text}
                    </MenuItem>))}
                </Select>
              }
              {error && <FormHelperText className='error-class'>{error}</FormHelperText>}
            </>
            :
            <OutlinedInput
              disabled={disable}
              id={id || label}
              type={type}
              value={value}
              placeholder={placeholder}
              // margin="normal"
              multiline={rows > 1}
              inputProps={{rows: rows, min: min, max: max,maxLength:item?.maxLength}}
              // inputProps={{rows: rows, min: min, max: max,maxLength:5}}
              required={required}
              fullWidth
              defaultValue={defaultValue}
              error={error}
              onChange={(event) =>
                onChange(event.target.value, id || label)
              }
              labelWidth={labelWidth}
              style={{border: 'none'}}
              endAdornment={
                item?.endAdornment && <InputAdornment position={item.endAdornment?.icon || 'end'}>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={item.endAdornment.onClick}
                    // onMouseDown={handleMouseDownPassword}
                  >
                    {item.endAdornment?.text &&
                    <p className='font-12 m-0 text-uppercase'>{item.endAdornment?.text}</p> || item.endAdornment?.icon}
                    {/*<Visibility />*/}
                  </IconButton>
                </InputAdornment>
              }
            />

        }
        {/*error message*/}
        {(type !== 'select') && <p className='error-class'>{error}</p>}
      </FormControl>
    </div>
  );
}

export default Input;
